import React from 'react';
import LoadingCircle from "../../../../../util/common/LoadingCircle";
import { withStyles } from "@mui/styles";
import ResultsGrid from "./ResultsGrid";
import PersonalityFacetsChart from "./PersonalityFacetsChart";
import Big5Chart from "./Big5Chart";
import NextSurvey from "../NextSurvey";
import AnswerTable from "./AnswerTable";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "0.625rem",
    textAlign: "center"
  },
  scoreSection: {
    border: "1px solid rgba(0,0,0,0.12)",
    padding: "1rem",
    minHeight: "calc( 2rem * 4 )",
    borderRadius: "4px",
    backgroundColor: "#fafafa",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },
  gridSection: {
    border: "1px solid rgba(0,0,0,0.12)",
    padding: "1rem",
    borderRadius: "4px",
    backgroundColor: "#fafafa",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
  },
  gridLabel: {
    fontSize: "1.0rem",
    fontWeight: 600,
    opacity: "0.8",
  },
  gridInfo: {
    fontSize: "0.7225rem",
    // fontWeight: 600,
    // opacity: "0.87",
  },
  scoreRow: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
  },
  label: {
    fontWeight: 600
  },
  hidden: {
    fontWeight: 600,
    opacity: 0
  },
  score: {
    fontSize: "2rem",
    fontWeight: 400
  },
};

function GratitudeExtras(){
  return <>
    <div>
      See a <a href="/v2/files/GQ-6-studies.pdf" target="_blank" rel="noopener noreferrer">complete list of results</a> from related studies.
    </div>
    <div>
      <a href="/v2/files/GratitudeQuestionnaire.pdf" target="_blank" rel="noopener noreferrer">About the Gratitude Questionnaire</a>
    </div>
  </>
}

function SurveyScore({score, interpretation, classes}){
  return <div className={classes.scoreSection}>
    <div className={classes.scoreRow}>
      <div className={classes.label}>Gratitude Score:</div>
      <div className={classes.score}>{ score }</div>
      <div className={classes.hidden}>Gratitude Score:</div>
    </div>
    <div>{ interpretation }</div>
    <GratitudeExtras />
  </div>
}

function MultipleChoiceResults(props) {
  const { folderId, surveyAttempt, jumpToQuestion, filterName, nextSurveyCallback, openDataView, isViewingShared, classes } = props;
  const score = surveyAttempt.results?.score;

  return(
    <div className={classes.root}>
      {isViewingShared ? null :
        <NextSurvey
          folderId={folderId}
          surveyAttempt={surveyAttempt}
          nextSurveyCallback={nextSurveyCallback}
          openDataView={openDataView}
          filterName={filterName}
        />
      }
      {!surveyAttempt.results ? <LoadingCircle />
        : <>
          {surveyAttempt.survey.survey_type !== "multiple-choice-2d" && surveyAttempt.survey.survey_type !== "shared-multiple-choice" ?
            surveyAttempt.survey.name.startsWith("AB5C") ? <PersonalityFacetsChart results={surveyAttempt.results}/>
              : surveyAttempt.survey.name.startsWith("Big-5") ? <Big5Chart results={surveyAttempt.results}/>
                : <SurveyScore score={score} interpretation={surveyAttempt.results?.interpretation} classes={classes}/>
            : null
          }
          <div className={classes.gridSection}>
            <div className={classes.gridLabel}>Answer Distribution</div>
            <ResultsGrid surveyAttempt={surveyAttempt} />
            <div className={classes.gridInfo}>This grid shows the total number of times each answer choice was selected.</div>
          </div>
          <AnswerTable surveyAttempt={surveyAttempt} jumpToQuestion={jumpToQuestion}/>
        </>
      }
    </div>
  )
}

export default withStyles(styles)(MultipleChoiceResults)
